import { gql } from "@apollo/client";

export const ADD_BLOCKED_PERIOD = gql`
  mutation addBlockedPeriod(
    $id: Int!,
    $from: Date!,
    $to: Date!
  ) {
    addBlockedPeriod(
      professionist_id: $id,
      from: $from,
      to: $to
  ) {
      id
    }
  }
`;
